module.exports = __webpack_public_path__ + "img/he1.7e9d032b.png";